// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"61efebb9","527":"bd010ec1","910":"dae0f5f9"}[chunkId] + ".chunk.js";
};